import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/simcontrol',
  },
  {
    path: "/setting",
    component: Layout,
    hidden: true,
    redirect: "/setting/:id",
    meta: {
      title: "更多",
      icon: "setting"
    },
    children: [
      {
        path: ":id",
        component: () => import("@/views/user/setting/index.vue"),
        meta: {
          title: "我的账户",
          icon: "user"
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  //匹配找不到的path页面
  {
    path: "*",
    component: () => import("@/views/error-page/404"),
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: "history",
  base: "/sim/",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js